export default {
  path: "/user/kiosco",
  component: () => import("@/views/user/kiosco/KioscoLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresKioskModule: true,
  },
  children: [
    {
      path: "",
      name: "kioscos-list",
      component: () => import("@/views/user/kiosco/KioscosListView.vue"),
    },
    {
      path: ":kioskId",
      name: "kiosk-home",
      component: () => import("@/views/user/kiosco/KioskHomeView.vue"),
      props: true,
    },
    {
      path: ":kioskId/admin",
      name: "kiosk-admin",
      component: () => import("@/views/user/kiosco/KioskAdminView.vue"),
      props: true,
    },
    {
      path: ":kioskId/menu/:menuId",
      name: "kiosk-menu-editor",
      component: () => import("@/views/user/kiosco/KioskMenuEditorView.vue"),
      props: true,
    },
    {
      path: ":kioskId/reservar",
      name: "kiosk-reservar",
      component: () => import("@/views/user/kiosco/KioskReservarView.vue"),
      props: true,
    },
    {
      path: ":kioskId/mis-pedidos",
      name: "kiosk-mis-pedidos",
      component: () => import("@/views/user/kiosco/KioskMisPedidosView.vue"),
      props: true,
    },
    {
      path: ":kioskId/entregas",
      name: "kiosk-entregas",
      component: () => import("@/views/user/kiosco/KioskEntregasView.vue"),
      props: true,
    },
    {
      path: ":kioskId/pedidos",
      name: "kiosk-pedidos",
      component: () => import("@/views/user/kiosco/KioskPedidosView.vue"),
      props: true,
    },
  ],
};
